import React, { lazy, Suspense, useEffect, useState, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Layout, Spin, Row } from 'antd'
import { appSelector } from '../helpers/appSelector'
import { AppDispatch } from '../helpers/appDispatch'
import { TransactionReport } from '../interfaces'
import { getOverviewRequest, clearPaymentData } from '../store/home'
import { isEmpty } from '../helpers/isEmpty'
import { getCurrentUser } from '../store/settings'

const Overview = lazy(() => import('../components/dashboard/Overview'))
const DashboardStats = lazy(() => import('../components/dashboard/DashboardStats'))
const EmptyBox = lazy(() => import('../components/dashboard/EmptyBox'))

const { Content } = Layout

const Dashboard = () => {
  const dispatch: AppDispatch = useDispatch()
  const { t } = useTranslation()
  const { user } = appSelector((state) => state.auth)
  const {
    client,
    error: clientError
  } = appSelector((state) => state.settings)
  const home = appSelector((state) => state.home)
  const { vasDashboard, collectionDashboard } = appSelector((state) => state.vasTransaction)
  const [loading, setLoading] = useState(false)
  const [currency, setCurrency] = useState('USD')
  const [fixedPeriod, setFixedPeriod] = useState('TODAY')
  const [trxReports, setTrxReports] = useState<TransactionReport | null>(null)
  const [params] = useState({
    currency: currency,
    fixedPeriod: fixedPeriod
  })

  const isWaitingForClient = !!user && isEmpty(client) && !clientError

  useEffect(() => {
    if (user && isEmpty(client)) {
      dispatch(getCurrentUser())
    }
  }, [client, dispatch, user])

  useEffect(() => {
    const { loading, trxReports } = home
    setLoading(loading)
    setTrxReports(trxReports)
  }, [home])

  const onReloadTransaction = useCallback(() => {
    dispatch(clearPaymentData())
    dispatch(getOverviewRequest(params))
  }, [dispatch, params])

  const onSelectCurrency = useCallback(
    (value: string) => {
      setCurrency(value)
    },
    []
  )

  const onSelectPeriod = useCallback(
    (value: string) => {
      setFixedPeriod(value)
    },
    []
  )

  const onRefreshPage = useCallback(() => {
    dispatch(getOverviewRequest(params))
  }, [dispatch, params])

  let container: React.ReactNode
  if (loading) {
    container = (
      <Row className="suspense-container">
        <Spin style={{ marginTop: '200px' }} />
      </Row>
    )
  }

  if (!loading && !trxReports) {
    container = (
      <EmptyBox onReloadTransaction={onReloadTransaction} translate={t} />
    )
  }

  return (
    <div className="padding-box">
      <Content className="site-layout-background site-box">
        <Suspense
          fallback={
            <Row className="suspense-container">
              <div style={{ marginTop: '200px' }}>
                <Spin />
              </div>
            </Row>
          }
        >
          {isWaitingForClient ? (
            <Row className="suspense-container">
              <div style={{ marginTop: '200px' }}>
                <Spin />
              </div>
            </Row>
          ) : (
            <DashboardStats
              trxReports={trxReports}
              vasDashboard={vasDashboard}
              collectionDashboard={collectionDashboard}
              currency={currency}
              fixedPeriod={fixedPeriod}
              onSelectCurrency={onSelectCurrency}
              onSelectPeriod={onSelectPeriod}
              translate={t}
            />
          )}
          {/* {container}
          {!loading && trxReports && (
            <Overview
              trxReports={trxReports}
              userRoles={user!.roles}
              currency={currency}
              fixedPeriod={fixedPeriod}
              loading={loading}
              translate={t}
            />
          )} */}
        </Suspense>
      </Content>
    </div>
  )
}

export default withRouter(Dashboard)
